import React, { Component } from "react";
export default class AlternationSection extends Component {
  render() {
    var {
      executive_alternation_trial1,
      executive_alternation_trial2,
      executive_alternation_trial3,
      executive_alternation_trial4,
      executive_alternation_trial5,
      executive_alternation_trial6,
      executive_alternation_trial7,
      executive_alternation_trial8,
      executive_alternation_trial9,
      executive_alternation_trial10,
      executive_alternation_trial11,
      executive_alternation_trial12,
      executive_alternation_score,
    } = this.props.data;
    return (
      <div className="row border border-dark alternation_section">
         <div className="col-lg-10">
        </div>
        <div className="col-lg-2 pt-4" style={{ borderLeft: "1px solid #000" }}>
          <div>
            <span className="fs-18">Score (0-12) </span>
            <input
              disabled
              type="number"
              name="executive_alternation_score"
              value={executive_alternation_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
